<template>
  <div class="Home">
    <el-carousel class="elCarousel" :autoplay="true" :interval="3000">
      <el-carousel-item v-for="(item, index) in carouselArr" :key="item.id" @click.native="handleCarouselClick(item)">
        <!-- style="width: 19.2rem; height: 6.42rem" -->
        <el-image :src="item.imgUrl" class="custom-image"></el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 解决方案 -->
    <!--<div class="solution">
      <div class="solutionBox">
        <div class="solutionBox_top">
          <img src="@/assets/img/sy/sy_jjfa.png" alt="" />
        </div>
        <div class="solutionBox_bottom">
          <div class="solutionBox_bottomBox">
            <div class="left">
              &lt;!&ndash; 解决方案滚动容器 &ndash;&gt;
              <div
                class="solution-scroll-container"
                @scroll="handleSolutionScroll"
                ref="solutionScrollContainer"
              >
                <div class="leftItem" v-for="(item, index) in totalSolutionArr" :key="item.id" @click="solutionClick(index, item)"
                  :class="[solutionIndex === index ? 'active' : '']">
                  <div>{{ String(index + 1).padStart(2, '0') }}</div>
                  <div class="leftItem_text">
                    <div>
                      {{ item.name }}
                    </div>
                    <div>
                      发布于：{{ item.createTime }}
                    </div>
                  </div>

                  <div class="leftItem_right">
                    <img src="@/assets/img/sy/sy_jjfaj.png" alt="" v-show="solutionIndex === index" />
                  </div>
                </div>

                &lt;!&ndash; 加载状态 &ndash;&gt;
                <div v-if="isSolutionLoading" class="solution-loading">
                  <div class="loading-spinner"></div>
                  <span>正在加载更多方案...</span>
                </div>

                &lt;!&ndash; 无更多数据提示 &ndash;&gt;
                <div v-if="!hasMoreSolutions && totalSolutionArr.length > 0" class="no-more-solutions">
                  <span>已显示全部解决方案</span>
                </div>

                &lt;!&ndash; 空数据提示 &ndash;&gt;
                <div v-if="totalSolutionArr.length === 0 && !isSolutionLoading" class="empty-solutions">
                  <span>暂无解决方案数据</span>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="solution-image-container" @click="goToSolutionDetail">
                <img :src="currentSolutionImage" alt="解决方案图片" />
                <div class="solution-overlay">
                  <div class="solution-overlay-content">
                    <div class="solution-name">{{ currentSolutionName }}</div>
                    <div class="view-detail-btn">查看详情</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <!-- 新的解决方案 -->
    <div class="scheme">
      <div>
        <div>
          <span style="color: #333333;">林草湿病虫害最佳</span><span style="color: #1C7E28;">实践解决方案</span>
        </div>
        <div style="margin-top: 20px;">深耕客户业务场景，从需求沟通到使用反馈，全方位打造更懂业务的智能解决方案</div>
      </div>
      <div class="img-box">
        <!-- 图片1：无人机竹蝗防治 -->
        <div class="scheme-card" data-index="0" @click="goToSolution(3)">
          <img class="stats-bg" src="@/assets/img/home/sy_wrj.png" alt="" />
          <div class="scheme-overlay">
            <div class="overlay-title">防治解决方案</div>
            <div class="overlay-desc">立足森林生态，以营林预防为根基，按需合理施用化学药剂，统筹飞防、天敌繁育、人工除治等举措，将病虫鼠害控制在受害阈值内，是国内林业病虫治理主流准则。</div>
          </div>
          <div class="nextstep-icon">
            <img src="@/assets/img/home/icon-nextstep.png" alt="下一步" />
          </div>
        </div>

        <!-- 图片2：康硕电气空天地一体化森林消防灭火装备 -->
        <div class="scheme-card" data-index="1" @click="goToSolution(2)">
          <img class="stats-bg" src="@/assets/img/home/sy_fh.png" alt="" />
          <div class="scheme-overlay">
            <div class="overlay-title">硬件解决方案</div>
            <div class="overlay-desc">集成空天地一体化监测、靶向防治、应急处置全链条设备，覆盖虫情测报、智能识别、精准施药、指挥调度等场景，为林草湿病虫害防控提供高效、稳定、可靠的硬件支撑体系。</div>
          </div>
          <div class="nextstep-icon">
            <img src="@/assets/img/home/icon-nextstep.png" alt="下一步" />
          </div>
        </div>

        <!-- 图片3：冕宁“油橄榄林区一体化智能管控平台 -->
        <div class="scheme-card" data-index="2" @click="goToSolution(1)">
          <img class="stats-bg" src="@/assets/img/home/sy_zn.png" alt="" />
          <div class="scheme-overlay">
            <div class="overlay-title">软件解决方案</div>
            <div class="overlay-desc">基于 GIS、大数据与 AI 技术，构建集监测预警、数据分析、作业调度、效果评估于一体的林草湿病虫害智能管控平台，实现防控工作的数字化、可视化、精细化管理。</div>
          </div>
          <div class="nextstep-icon">
            <img src="@/assets/img/home/icon-nextstep.png" alt="下一步" />
          </div>
        </div>

        <!-- 图片4：一体化的林草病虫害防控体系（带图标和按钮） -->
        <div class="scheme-card" data-index="3">
          <img class="stats-bg" src="@/assets/img/home/sy_fkx.png" alt="" />
          <div class="scheme-overlay scheme-overlay-complex">
            <div class="overlay-title">一体化的林草湿病虫害防控体系</div>
            <div class="overlay-subtitle">全面破解林草湿病虫害监测滞后、鉴定不准、防治粗放、溯源困难等行业痛点，守护林草生态安全，助力生态保护与林业产业高质量发展。</div>
            <div class="overlay-feature">
              <img src="@/assets/img/home/sy_dh.png" class="feature-icon" />
              <span>实现疑难物种、变异个体的精准定种与溯源，破解近缘种识别难题</span>
            </div>
            <div class="overlay-feature">
              <img src="@/assets/img/home/sy_dh.png" class="feature-icon" />
              <span>实现病虫害早发现、早预警、早报告，严格执行监测信息报送制度</span>
            </div>
            <div class="overlay-feature">
              <img src="@/assets/img/home/sy_dh.png" class="feature-icon" />
              <span>推动防控工作常态化、规范化，结合树种科学配置等生态调控手段</span>
            </div>
            <div class="overlay-buttons">
              <button class="scheme-btn custom-btn" @click.stop="openMessageDialog">定制解决方案</button>
              <button class="scheme-btn more-btn" @click.stop="goToSolution()">更多实践方案</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 产品分类模块 -->
    <div class="product-categories">
      <!-- 隔离区背景 -->
      <!--<div class="separator-background">-->
      <!--  <img src="@/assets/img/sy/sy_b2.png" alt="背景" />-->
      <!--</div>-->

      <div class="product-categories-container">
        <div
          v-for="(category, categoryIndex) in filteredProductCategories"
          :key="category.id"
          class="category-wrapper"
          :class="getCategoryStyleClass(categoryIndex)"
          :style="[{
            ...getCategoryHeaderStyle(categoryIndex),
            ...getCategoryBgImageStyle(categoryIndex) // 新增：背景图片样式
          }]"
        >
          <!-- 标题模块 -->
          <div class="category-title-section" :style="getCategoryHeaderStyle(categoryIndex)">
            <div class="category-info">
              <h3 class="category-name">{{ category.name }}</h3>
              <!-- 标记条 -->
              <div class="category-divider">
                <img :src="getCategoryDividerImage(categoryIndex)" alt="分隔线" />
              </div>
            </div>
            <div class="category-button" @click="goToCategoryDetail(category)">
              <img :src="getCategoryButtonImage(categoryIndex)" alt="查看全部" />
            </div>
          </div>

          <!-- 产品展示模块 -->
          <div class="category-products-section">
            <div class="category-products">
              <div
                v-for="(product, productIndex) in category.products.slice(0, 4)"
                :key="product.id"
                class="product-card"
                @click="goToProductDetail(product)"
              >
                <div class="product-image-section">
                  <img
                    :src="product.imgUrlList && product.imgUrlList[0] ? product.imgUrlList[0] : defaultProductImage"
                    :alt="product.productName"
                  />
                </div>
                <div class="product-info-section">
                  <h4 class="product-name" :title="product.productName">{{ product.productName }}</h4>
                  <p class="product-brief" :title="product.brief">{{ product.brief }}</p>
                </div>
                <div class="card-hover-overlay">
                  <div class="overlay-content">
                    <div class="overlay-title">{{ product.productName }}</div>
                    <div class="overlay-brief">{{ product.brief }}</div>
                    <img src="@/assets/img/home/sy_jiahao.png" class="overlay-plus" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态提示 -->
      <div v-if="isLoadingMore" class="loading-more">
        <div class="loading-spinner"></div>
        <span>正在加载更多分类...</span>
      </div>

      <div v-if="!hasMoreCategories && productCategories.length > 0" class="no-more-data">
        <span>已显示全部产品分类</span>
      </div>
    </div>
    <!-- 留言弹窗（定制解决方案） -->
    <el-dialog
      title="定制解决方案"
      :visible.sync="messageDialogVisible"
      width="650px"
      append-to-body
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-form
        :rules="messageRules"
        :model="messageForm"
        ref="messageFormRef"
        label-position="top"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="messageForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="department">
          <el-input v-model="messageForm.department" placeholder="请输入所属部门"></el-input>
        </el-form-item>

        <el-form-item label="职务" prop="title">
          <el-input v-model="messageForm.title" placeholder="请输入职务"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="messageForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="留言内容" prop="comment">
          <el-input type="textarea" :rows="2" v-model="messageForm.comment" placeholder="请输入留言内容"></el-input>
        </el-form-item>

        <div class="dialog-footer" style="text-align: center; margin-top: 20px;">
          <el-button @click="messageDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitMessageForm">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Banner from "@/api/banner.js";
import ArticleCenter from "@/api/articleCenter.js";
import Plan from "@/api/plan.js";
import Product from "@/api/product.js";
import bgImg1 from '@/assets/img/home/1.png';
import bgImg2 from '@/assets/img/home/2.png';
import bgImg3 from '@/assets/img/home/3.png';
import MessageCenter from "@/api/messageCenter.js";

export default {
  name: "Home",
  data() {
    return {
      carouselArr: [], //banner
      totalSolutionArr: [], //方案数据
      solutionIndex: 0,
      currentSolutionImage: require("@/assets/img/sy/sy_tu1.png"),
      currentSolutionName: "",
      currentSolutionItem: null,

      // 产品分类相关数据
      productCategories: [], // 产品分类列表，每个分类包含其下的产品
      categoryList: [], // 所有产品分类
      defaultProductImage: require("@/assets/img/sy/noData.png"), // 默认产品图片
      loading: false,

      // 分页相关
      currentPage: 1,
      pageSize: 5,
      hasMoreCategories: true, // 是否还有更多分类
      isLoadingMore: false, // 是否正在加载更多
      totalCategories: 0, // 总分类数量
      scrollTimer: null, // 用于防抖处理

      // 解决方案分页相关
      solutionCurrentPage: 1,
      solutionPageSize: 4,
      isSolutionLoading: false,
      hasMoreSolutions: true,
      totalSolutions: 0,
      solutionScrollTimer: null,

      // 留言弹窗
      messageDialogVisible: false,
      messageForm: {
        name: '',
        department: '',
        title: '',
        phone: '',
        comment: ''
      },
      messageRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        department: [{ required: true, message: '请输入所属部门', trigger: 'blur' }],
        title: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
        ],
        comment: [{ required: true, message: '请输入留言内容', trigger: 'blur' }]
      }
    };
  },
  computed: {
    // 过滤掉没有产品的分类
    filteredProductCategories() {
      return this.productCategories.filter(category =>
        category.products && category.products.length > 0
      );
    }
  },
  methods: {
    // 页面数据加载方法（供mixin调用）
    async loadAllPageData() {
      // 重置解决方案分页状态
      this.solutionCurrentPage = 1;
      this.hasMoreSolutions = true;
      this.isSolutionLoading = false;
      this.totalSolutions = 0;

      // 并行加载所有数据
      await Promise.all([
        this.getBannerList(),
        this.getTotalSolutionList(),
        this.getProductCategoriesList()
      ]);
    },

    solutionClick(index, item) {
      this.solutionIndex = index;
      this.currentSolutionImage = item.imgUrl || require("@/assets/img/sy/sy_tu1.png");
      this.currentSolutionName = item.name;
      this.currentSolutionItem = item;
    },

    //banner
    async getBannerList() {
      const params = {
        page: 1,
        pageSize: 10
      };
      const { code, msg, data, total } = await Banner.queryList(params);
      if (code === 200) {
        // 过滤enable为1的数据
        this.carouselArr = data.filter(item => item.enable === 1);
      } else {
        this.$message.error(msg);
      }
    },

    //解决方案
    async getTotalSolutionList() {
      try {
        this.isSolutionLoading = true;
        const params = {
          name: "",
          startTime: "",
          endTime: "",
          page: this.solutionCurrentPage,
          pageSize: this.solutionPageSize,
          type: null
        };

        const { code, msg, data, total } = await Plan.queryAcList(params);
        if (code === 200) {
          // 更新总数量
          this.totalSolutions = total || 0;

          if (data && data.length > 0) {
            // 过滤betterStatus为1的数据
            const filteredData = data.filter(item => item.betterStatus === 1);

            if (this.solutionCurrentPage === 1) {
              // 第一页直接赋值
              this.totalSolutionArr = filteredData;
              // 初始化第一个方案的显示
              if (filteredData.length > 0) {
                this.solutionIndex = 0;
                this.currentSolutionImage = filteredData[0].imgUrl || require("@/assets/img/sy/sy_tu1.png");
                this.currentSolutionName = filteredData[0].name;
                this.currentSolutionItem = filteredData[0];
              }
            } else {
              // 后续页面追加数据，避免重复
              const existingIds = this.totalSolutionArr.map(item => item.id);
              const newData = filteredData.filter(item => !existingIds.includes(item.id));
              this.totalSolutionArr = [...this.totalSolutionArr, ...newData];
            }

            // 判断是否还有更多数据
            if (data.length < this.solutionPageSize || this.totalSolutionArr.length >= this.totalSolutions) {
              this.hasMoreSolutions = false;
            }
          } else {
            // 如果返回空数组
            if (this.solutionCurrentPage === 1) {
              this.totalSolutionArr = [];
              this.currentSolutionImage = require("@/assets/img/sy/sy_tu1.png");
              this.currentSolutionName = "";
              this.currentSolutionItem = null;
            }
            this.hasMoreSolutions = false;
          }
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.error('获取解决方案失败:', error);
        this.$message.error('获取解决方案失败');
      } finally {
        this.isSolutionLoading = false;
      }
    },

    // 获取产品分类列表
    async getProductCategoriesList() {
      try {
        this.loading = true;
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize
        };

        const { code, msg, data, total } = await Product.productCategoryList(params);
        if (code === 200) {
          // 更新总数量
          this.totalCategories = total || 0;

          if (data && data.length > 0) {
            // 过滤掉startStatus为0的分类，只显示startStatus为1的分类
            const enabledCategories = data.filter(item => item.startStatus === 1);

            // 检查并避免重复分类
            const newCategories = enabledCategories.filter(newCategory =>
              !this.categoryList.some(existingCategory => existingCategory.id === newCategory.id)
            );

            if (newCategories.length > 0) {
              // 如果是第一页，直接赋值；否则追加新的不重复的数据
              if (this.currentPage === 1) {
                this.categoryList = enabledCategories;
              } else {
                this.categoryList = [...this.categoryList, ...newCategories];
              }

              // 为新获取的分类获取产品数据
              await this.getProductsForCategories(newCategories);
            } else {
              // 如果没有新的分类数据，说明已经没有更多数据了
              this.hasMoreCategories = false;
              if (this.currentPage > 1) {
                this.$message.info('当前已经是全部产品分类信息了');
              }
            }

            // 根据已加载的数量和总数量判断是否还有更多数据
            if (this.categoryList.length >= this.totalCategories) {
              this.hasMoreCategories = false;
            }

            // 如果本次返回的数据量少于页面大小，说明已经是最后一页
            if (data.length < this.pageSize) {
              this.hasMoreCategories = false;
            }
          } else {
            // 如果返回空数组
            if (this.currentPage === 1) {
              this.categoryList = [];
              this.productCategories = [];
            }
            this.hasMoreCategories = false;
            if (this.currentPage > 1) {
              this.$message.info('当前已经是全部产品分类信息了');
            }
          }
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.error('获取产品分类失败:', error);
        this.$message.error('获取产品分类失败');
      } finally {
        this.loading = false;
        this.isLoadingMore = false;
      }
    },

    // 为指定分类获取产品数据
    async getProductsForCategories(categories) {
      try {
        const promises = categories.map(async (category) => {
          const params = {
            productName: "",
            productTypeId: category.id,
            page: 1,
            pageSize: 4, // 每个分类获取4个产品
            startTime: "",
            endTime: ""
          };

          const { code, data } = await Product.queryList(params);
          if (code === 200) {
            // 过滤启用状态的产品，并处理每个产品的图片URL
            const enabledProducts = (data || []).filter(product => product.enable === 1).map(product => {
              if (product.imageUrl) {
                try {
                  // imageUrl是JSON字符串数组，需要解析
                  const imageUrlArray = JSON.parse(product.imageUrl);
                  if (Array.isArray(imageUrlArray)) {
                    product.imgUrlList = imageUrlArray;
                  } else {
                    product.imgUrlList = [product.imageUrl];
                  }
                } catch (parseError) {
                  console.warn('解析产品图片URL失败:', parseError);
                  product.imgUrlList = [product.imageUrl];
                }
              } else {
                product.imgUrlList = [];
              }
              return product;
            });

            return {
              ...category,
              products: enabledProducts
            };
          }
          return {
            ...category,
            products: []
          };
        });

        const newCategoriesWithProducts = await Promise.all(promises);

        // 避免重复添加分类，检查是否已存在
        const filteredNewCategories = newCategoriesWithProducts.filter(newCategory =>
          !this.productCategories.some(existingCategory => existingCategory.id === newCategory.id)
        );

        if (this.currentPage === 1) {
          // 如果是第一页，直接赋值
          this.productCategories = newCategoriesWithProducts;
        } else {
          // 如果是追加数据，只添加不重复的分类
          this.productCategories = [...this.productCategories, ...filteredNewCategories];
        }
      } catch (error) {
        console.error('获取产品数据失败:', error);
        this.$message.error('获取产品数据失败');
      }
    },

    // 加载更多分类
    async loadMoreCategories() {
      // 如果正在加载中、没有更多数据、或者已经加载了所有数据，则直接返回
      if (this.isLoadingMore || !this.hasMoreCategories || this.loading) {
        return;
      }

      // 检查是否已经达到总数量限制
      if (this.totalCategories > 0 && this.categoryList.length >= this.totalCategories) {
        this.hasMoreCategories = false;
        return;
      }

      this.isLoadingMore = true;
      this.currentPage++;
      await this.getProductCategoriesList();
    },

    // 滚动监听处理
    handleScroll() {
      // 如果没有更多数据或正在加载，直接返回，避免不必要的计算
      if (!this.hasMoreCategories || this.isLoadingMore || this.loading) {
        // console.log('滚动监听跳过: 没有更多数据或正在加载中', {
        //   hasMoreCategories: this.hasMoreCategories,
        //   isLoadingMore: this.isLoadingMore,
        //   loading: this.loading
        // });
        return;
      }

      // 防抖处理
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      this.scrollTimer = setTimeout(() => {
        // 再次检查状态，确保在延迟期间状态没有改变
        if (!this.hasMoreCategories || this.isLoadingMore || this.loading) {
          return;
        }

        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // 当滚动到距离底部200px时触发加载
        if (scrollTop + windowHeight >= documentHeight - 200) {
          console.log('触发加载更多分类', {
            currentPage: this.currentPage,
            categoryListLength: this.categoryList.length,
            totalCategories: this.totalCategories,
            hasMoreCategories: this.hasMoreCategories
          });
          this.loadMoreCategories();
        }
      }, 100);
    },

    // 跳转到产品详情页
    goToProductDetail(product) {
      if (product && product.productName !== "暂无产品" && product.id) {
        // 获取当前产品的分类信息
        const category = this.productCategories.find(cat =>
          cat.products && cat.products.some(p => p.id === product.id)
        );

        this.$router.push({
          path: '/productDetails',
          query: {
            projectId: product.id.toString(), // 传递产品ID
            // 保持分类信息用于面包屑导航
            fromCategoryId: category ? category.id : '',
            fromCategoryName: category ? category.name : ''
          }
        });
      } else {
        this.$message.info('暂无该产品数据');
      }
    },

    // 跳转到分类详情页
    goToCategoryDetail(category) {
      console.log('首页跳转到分类详情页，分类信息:', {
        id: category.id,
        name: category.name,
        idType: typeof category.id,
        nameType: typeof category.name
      });

      // 设置导航栏状态为产品中心（索引为1）
      this.$LocalCache.setCath("navigationBarIndex", 1);

      this.$router.push({
        path: '/productCenter',
        query: {
          categoryId: category.id,
          categoryName: category.name
        }
      }).catch(err => {
        // 处理路由跳转异常（如重复导航）
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err);
        }
      });
    },

    goPage(value) {
      this.$router.push(value);
    },

    goToSolutionDetail() {
      let targetItem = this.currentSolutionItem;

      // 如果没有当前选中的方案，使用第一个方案
      if (!targetItem && this.totalSolutionArr.length > 0) {
        targetItem = this.totalSolutionArr[0];
      }

      if (targetItem && targetItem.id) {
        // 跳转到解决方案详情页面，传递方案ID
        this.$router.push({
          path: '/solutionDetails',
          query: {
            planDataCenterId: targetItem.id.toString()
          }
        });
      } else {
        this.$message.info('暂无解决方案数据');
      }
    },

    handleCarouselClick(item) {
      // 处理轮播图项点击事件
      if (item.targetUrl) {
        // 检查URL是否是完整的URL（以http://或https://开头）
        const url = item.targetUrl.startsWith('http://') || item.targetUrl.startsWith('https://')
          ? item.targetUrl
          : `http://${item.targetUrl}`;

        // 在新窗口中打开链接
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },

    // 获取分类样式类
    getCategoryStyleClass(index) {
      return index % 2 === 0 ? 'green-theme' : 'blue-theme';
    },

    // 新增：获取分类背景图片样式
    getCategoryBgImageStyle(index) {
      if (index % 2 === 0) {
        const bgIndex = Math.floor(index / 2) % 3 + 1;
        let bgImage = '';
        if (bgIndex === 1) bgImage = bgImg1;
        else if (bgIndex === 2) bgImage = bgImg2;
        else if (bgIndex === 3) bgImage = bgImg3;

        // 关键：将相对路径 ./static/ 转换为绝对路径 /static/
        if (typeof bgImage === 'string' && bgImage.startsWith('./')) {
          bgImage = bgImage.substring(1); // 去掉开头的 . 变成 /static/img/xxx.png
        }

        let topOffset = '-40px';
        let bgSize = '100vw auto';
        if (bgIndex === 2) {
          topOffset = '-40px';
          bgSize = '112% auto';
        }

        return {
          '--bg-img': `url(${bgImage})`,   // 此时 bgImage 为 /static/img/1.9b5b3ae.png
          '--bg-top-offset': topOffset,
          '--bg-size': bgSize
        };
      }
      return {};
    },

    // 获取分类头部背景样式
    getCategoryHeaderStyle(index) {
      const bgImage = index % 2 === 0
        ? require('@/assets/img/sy/sy_cqd.png')
        : require('@/assets/img/sy/sy_bqd.png');

      return {
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    },

    // 获取分类按钮图片
    getCategoryButtonImage(index) {
      return index % 2 === 0
        ? require('@/assets/img/sy/sy_ckqb1.png')
        : require('@/assets/img/sy/sy_ckqb2.png');
    },

    // 获取分类分隔线图片
    getCategoryDividerImage(index) {
      return index % 2 === 0
        ? require('@/assets/img/sy/sy_xhx.png')
        : require('@/assets/img/sy/sy_dx.png');
    },

    // 解决方案滚动处理
    handleSolutionScroll() {
      if (!this.hasMoreSolutions || this.isSolutionLoading) {
        return;
      }

      // 防抖处理
      if (this.solutionScrollTimer) {
        clearTimeout(this.solutionScrollTimer);
      }

      this.solutionScrollTimer = setTimeout(() => {
        if (!this.hasMoreSolutions || this.isSolutionLoading) {
          return;
        }

        const container = this.$refs.solutionScrollContainer;
        if (!container) return;

        const { scrollTop, scrollHeight, clientHeight } = container;
        const threshold = 50; // 距离底部50px时触发加载

        if (scrollTop + clientHeight >= scrollHeight - threshold) {
          this.loadMoreSolutions();
        }
      }, 100);
    },

    // 加载更多解决方案
    async loadMoreSolutions() {
      if (this.isSolutionLoading || !this.hasMoreSolutions) {
        return;
      }

      // 检查是否已经达到总数量限制
      if (this.totalSolutions > 0 && this.totalSolutionArr.length >= this.totalSolutions) {
        this.hasMoreSolutions = false;
        return;
      }

      this.solutionCurrentPage++;
      await this.getTotalSolutionList();
    },

    // 跳转到解决方案列表页555
    goToSolution(type) {
      // this.$router.push('/solution');
      if (type !== undefined && type !== null) {
        // 传递类型参数：1=软件方案，2=硬件方案，3=防治方案
        this.$router.push({
          path: '/solution',
          query: { type: type.toString() }
        });
      } else {
        // 不传参数，显示全部
        this.$router.push('/solution');
      }
    },

    // 打开留言弹窗
    openMessageDialog() {
      this.messageDialogVisible = true;
    },

    // 提交留言表单
    submitMessageForm() {
      this.$refs.messageFormRef.validate(async (valid) => {
        if (!valid) return;

        const params = {
          name: this.messageForm.name,
          department: this.messageForm.department,
          title: this.messageForm.title,
          phone: this.messageForm.phone,
          comment: this.messageForm.comment,
          checkStatus: 0,
          delStatus: 0
        };

        try {
          const { code, msg } = await MessageCenter.addOrUpDateList(params);
          if (code === 200) {
            this.$message.success(msg || '留言提交成功，我们会尽快联系您！');
            this.messageDialogVisible = false;
            // 重置表单
            this.$refs.messageFormRef.resetFields();
            this.messageForm = { name: '', department: '', title: '', phone: '', comment: '' };
          } else {
            this.$message.error(msg || '提交失败，请稍后重试');
          }
        } catch (error) {
          console.error('提交留言失败', error);
          this.$message.error('提交失败，请稍后重试');
        }
      });
    }
  },
  mounted() {
    console.log('bgImg1:', bgImg1);
    console.log('bgImg2:', bgImg2);
    console.log('bgImg3:', bgImg3);
    // 路由守卫已经确保token存在，直接加载数据
    this.loadAllPageData();

    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);

    // 页面加载后自动滚动到页面顶部
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);

    // 清理定时器
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }

    // 清理解决方案滚动定时器
    if (this.solutionScrollTimer) {
      clearTimeout(this.solutionScrollTimer);
      this.solutionScrollTimer = null;
    }
  }
};
</script>

<style scoped lang="scss">
.Home {
  width: 100%;
  margin: 0 0 130px 0;
  position: relative;

  .elCarousel {
    width: 100%;
    height: 642px;

    .el-carousel__item {
      cursor: pointer;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.01);
      }
    }

    .custom-image {
      width: 100%;
      height: 642px;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  .solution {
    width: 100%;
    height: 670px;
    display: flex;
    justify-content: center;
    margin-top: 50px;

    .solutionBox {
      width: 1206px;
      height: 670px;
      display: flex;
      flex-direction: column;

      .solutionBox_top {
        width: 100%;
        height: 87px;

        img {
          width: 228px;
          height: 87px;
        }
      }

      .solutionBox_bottom {
        flex: 1;
        padding-top: 20px;

        .solutionBox_bottomBox {
          width: 100%;
          height: 527px;
          display: flex;

          .left {
            width: 540px;
            height: 527px;
            display: flex;
            flex-direction: column;

            .solution-scroll-container {
              height: 100%;
              max-height: 456px; // 限制高度显示4条数据 (114px * 4)
              overflow-y: auto;
              padding-right: 10px;

              /* 自定义滚动条样式 */
              &::-webkit-scrollbar {
                width: 6px;
              }

              &::-webkit-scrollbar-track {
                background: #f8f8f8;
                border-radius: 3px;
              }

              &::-webkit-scrollbar-thumb {
                background: #1c7e28;
                border-radius: 3px;

                &:hover {
                  background: #15621f;
                }
              }

              .leftItem {
                width: 100%;
                height: 114px;
                padding: 0 14px;
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                &:nth-child(1) {
                  margin-top: 10px !important;
                }

                &:hover {
                  cursor: pointer;
                }

                div {
                  &:nth-child(1) {
                    height: 90px;
                    font-size: 80px;
                  }
                }

                .leftItem_text {
                  width: 306px;
                  height: 90px;
                  padding-top: 10px;

                  div {
                    &:nth-child(1) {
                      width: 100%;
                      height: 30px;
                      font-size: 20px;
                      font-weight: 700;
                    }

                    &:nth-child(2) {
                      width: 100%;
                      height: 48px;
                      line-height: 22px;
                      font-size: 16px;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                  }
                }

                .leftItem_right {
                  width: 28px;
                  height: 70px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }
              }

              .active {
                color: #1c7e28;
                border-bottom: 1px solid #1c7e28;
              }
            }

            .solution-loading {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 20px 0;
              color: #666;
              font-size: 14px;

              .loading-spinner {
                width: 16px;
                height: 16px;
                border: 2px solid #f3f3f3;
                border-top: 2px solid #1c7e28;
                border-radius: 50%;
                animation: spin 1s linear infinite;
                margin-right: 8px;
              }
            }

            .no-more-solutions,
            .empty-solutions {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 20px 0;
              color: #999;
              font-size: 14px;
              text-align: center;

              span {
                padding: 8px 16px;
                background: #f5f5f5;
                border-radius: 16px;
                border: 1px solid #e0e0e0;
              }
            }
          }

          .right {
            flex: 1;
            padding-left: 52px;
            padding-top: 10px;

            .solution-image-container {
              position: relative;
              cursor: pointer;
              width: 100%;
              height: 507px;
              overflow: hidden;
              border-radius: 8px;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
              }

              .solution-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(29, 126, 41, 0.8);
                opacity: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: opacity 0.3s ease;
                border-radius: 8px;

                .solution-overlay-content {
                  text-align: center;
                  color: white;

                  .solution-name {
                    font-size: 20px;
                    font-weight: 700;
                    margin-bottom: 15px;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
                  }

                  .view-detail-btn {
                    background: rgba(255, 255, 255, 0.2);
                    border: 2px solid white;
                    padding: 8px 20px;
                    border-radius: 20px;
                    font-size: 16px;
                    font-weight: 500;
                    transition: all 0.3s ease;

                    &:hover {
                      background: white;
                      color: #1D7E29;
                    }
                  }
                }
              }

              &:hover {
                .solution-overlay {
                  opacity: 1;
                }

                img {
                  transform: scale(1.05);
                }
              }
            }
          }
        }
      }
    }
  }

  .scheme {
    width: 60%;                     // 左右各留白20%，内容区60%
    margin: 0 auto;                 // 水平居中
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;

    // 文本区域样式
    > div:first-child {
      text-align: center;
      margin-bottom: 30px;

      div:first-child {
        font-size: 32px;
        font-weight: bold;
        color: #1D7E29;             // 主题色可自行调整
        margin-bottom: 10px;
      }
      div:last-child {
        font-size: 16px;
        color: #666;
        line-height: 1.5;
      }
    }

    .img-box {
      display: flex;
      justify-content: center;
      gap: 10px;
      flex-wrap: nowrap;
      width: 100%;
      margin: 0;
      overflow-x: auto;
      padding-bottom: 5px;

      > div {
        flex: 0 0 auto;
        line-height: 0;
        position: relative;
        overflow: hidden;
        cursor: pointer;
      }

      .scheme-card{
        .nextstep-icon {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 20px;         // 距离卡片底部 20px，可根据需要改为 top: 80%
          z-index: 10;

          img {
            width: 20px;
            height: auto;
            cursor: pointer;
            transition: transform 0.2s, opacity 0.2s;

            &:hover {
              transform: scale(1.1);
              opacity: 0.8;
            }
          }
        }
      }

      .stats-bg {
        height: 30vw;
        max-height: 450px;
        min-height: 200px;
        width: auto;
        display: block;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      // 前三张卡片：左对齐，顶部对齐，增大行间距
      .scheme-overlay:not(.scheme-overlay-complex) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;     // 改为顶部对齐
        align-items: flex-start;
        text-align: left;
        padding: 20px 10px;
        box-sizing: border-box;
        opacity: 1;
        overflow-y: auto;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
        pointer-events: none;

        .overlay-title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 15px;
          line-height: 1.5;
        }
        .overlay-subtitle {
          font-size: 14px;
          margin-bottom: 15px;
          color: #ffd966;
          font-weight: 500;
          line-height: 1.5;
        }
        .overlay-desc {
          font-size: 13px;
          line-height: 1.6;
          opacity: 0.9;
          max-width: 90%;
        }
      }

      // 第四张卡片复杂布局样式（文字颜色 #333333，左右边距与前三张一致，左对齐，垂直居中保持原样）
      .scheme-overlay-complex {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;          // 第四张仍保持垂直居中（可根据需求调整）
        align-items: flex-start;
        text-align: left;
        padding: 20px;
        box-sizing: border-box;
        opacity: 1;
        overflow-y: auto;
        color: #333333;
        text-shadow: none;
        pointer-events: none;

        .overlay-title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 15px;
          line-height: 1.5;
          color: #333333;
        }
        .overlay-subtitle {
          font-size: 14px;
          margin-bottom: 20px;
          line-height: 1.5;
          color: #333333;
        }
        .overlay-feature {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 15px;
          font-size: 13px;
          line-height: 1.5;
          color: #333333;
          width: 100%;
          .feature-icon {
            width: 20px;
            height: 20px;
            flex-shrink: 0;
          }
        }
        .overlay-buttons {
          display: flex;
          gap: 15px;
          margin-top: 15px;
          justify-content: flex-start;
          width: 100%;
          pointer-events: auto;
          .scheme-btn {
            background: white;
            color: #333333;
            border: 1px solid #ddd;
            padding: 8px 20px;
            border-radius: 30px;
            font-size: 13px;
            cursor: pointer;
            transition: all 0.2s ease;
            font-weight: 500;
            &:hover {
              background: #1C7E28;
              color: white;
              border-color: #1C7E28;
            }
          }
        }
      }
    }

    // 移动端适配
    @media (max-width: 768px) {
      .img-box {
        gap: 8px;
        .stats-bg {
          height: 25vw;
          max-height: 200px;
        }
        .scheme-overlay:not(.scheme-overlay-complex) {
          padding: 15px;
          .overlay-title {
            font-size: 14px;
            margin-bottom: 10px;
          }
          .overlay-subtitle {
            font-size: 12px;
            margin-bottom: 10px;
          }
          .overlay-desc {
            font-size: 11px;
            line-height: 1.4;
          }
        }
        .scheme-overlay-complex {
          padding: 15px;
          .overlay-title {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .overlay-subtitle {
            font-size: 12px;
            margin-bottom: 15px;
          }
          .overlay-feature {
            font-size: 11px;
            gap: 6px;
            margin-bottom: 10px;
          }
          .overlay-buttons .scheme-btn {
            padding: 5px 12px;
            font-size: 11px;
          }
        }
      }
    }

    // 移动端适配（保持边距一致，适当缩小）
    @media (max-width: 768px) {
      .img-box {
        gap: 8px;
        .stats-bg {
          height: 25vw;
          max-height: 200px;
        }
        .scheme-overlay:not(.scheme-overlay-complex) {
          padding: 15px;
          .overlay-title {
            font-size: 14px;
            margin-bottom: 10px;
          }
          .overlay-subtitle {
            font-size: 12px;
            margin-bottom: 10px;
          }
          .overlay-desc {
            font-size: 11px;
            line-height: 1.4;
          }
        }
        .scheme-overlay-complex {
          padding: 15px;
          .overlay-title {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .overlay-subtitle {
            font-size: 12px;
            margin-bottom: 15px;
          }
          .overlay-feature {
            font-size: 11px;
            gap: 6px;
            margin-bottom: 10px;
          }
          .overlay-buttons .scheme-btn {
            padding: 5px 12px;
            font-size: 11px;
          }
        }
      }
    }

    // 移动端适配
    @media (max-width: 768px) {
      .img-box {
        gap: 8px;
        .stats-bg {
          height: 25vw;
          max-height: 200px;
        }
        .scheme-overlay {
          padding: 12px;
          .overlay-title {
            font-size: 14px;
          }
          .overlay-subtitle {
            font-size: 12px;
          }
          .overlay-desc {
            font-size: 11px;
          }
        }
        .scheme-overlay-complex {
          .overlay-title {
            font-size: 16px;
          }
          .overlay-feature {
            font-size: 11px;
            gap: 6px;
            margin-bottom: 10px;
          }
          .overlay-buttons .scheme-btn {
            padding: 5px 12px;
            font-size: 11px;
          }
        }
      }
    }

    // 移动端适配
    @media (max-width: 768px) {
      .img-box {
        gap: 8px;
        .stats-bg {
          height: 25vw;
          max-height: 200px;
        }
        .scheme-overlay {
          padding: 12px;
          .overlay-title {
            font-size: 14px;
          }
          .overlay-subtitle {
            font-size: 12px;
          }
          .overlay-desc {
            font-size: 11px;
          }
        }
        .scheme-overlay-complex {
          .overlay-title {
            font-size: 16px;
          }
          .overlay-feature {
            font-size: 11px;
            gap: 6px;
            margin-bottom: 10px;
          }
          .overlay-buttons .scheme-btn {
            padding: 5px 12px;
            font-size: 11px;
          }
        }
      }
    }

  }

  // 大屏幕固定高度（可选）
  @media (min-width: 1600px) {
    .scheme .img-box .stats-bg {
      height: 400px;                // 固定高度，避免过大
    }
  }

  // 移动端适配
  @media (max-width: 768px) {
    .scheme {
      width: 90%;                   // 移动端减少左右留白
    }
    .scheme .img-box .stats-bg {
      height: 25vw;                // 更小的高度
      max-height: 200px;
    }
    .scheme .img-box {
      gap: 8px;
    }
  }

  // 产品分类模块样式
  .product-categories {
    overflow: visible !important;
    width: 100%;
    position: relative;
    padding: 0;
    margin-top: 50px;

    .separator-background {
      width: 100%;
      height: 105px;
      overflow: hidden;
      position: relative;
      margin-bottom: -53px; // 让分类模块覆盖在隔离区的一半（105px的一半约53px）

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .product-categories-container {
      width: 1206px;
      max-width: 1206px;
      margin: 0 auto;
      position: relative;
      z-index: 2;

      // 新增
      .category-wrapper::before {
        content: '';
        position: absolute;
        top: var(--bg-top-offset, -40px);   // 动态控制向上延伸距离
        left: 50%;
        transform: translateX(-50%);
        width: 100vw;
        height: calc(100% + 80px);
        background-image: var(--bg-img);
        background-repeat: no-repeat;
        background-size: var(--bg-size, 100vw auto);
        background-position: center top;     // 图片从顶部开始对齐
        z-index: 1;
        pointer-events: none;
      }

      /* 保证内容在背景上面 */
      .category-wrapper > * {
        position: relative;
        z-index: 2;
      }

      .category-wrapper {
        position: relative;
        margin-bottom: 60px;

        .category-title-section {
          height: 120px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 40px;
          position: relative;
          margin-bottom: 20px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

          .category-info {
            flex: 1;

            .category-name {
              font-weight: 800;
              font-size: 30px;
              margin: 0 0 11px 0;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
            }

            .category-divider {
              margin: 0;

              img {
                width: auto;
              }

            }
          }

          .category-button {
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
              transform: scale(1.05);
            }

          }
        }

        .category-products-section {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          padding: 30px 40px 40px 40px;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
          }

          .category-products {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
            padding: 0;

            .product-card {
              background: #F7F8FC;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
              transition: all 0.3s ease;
              cursor: pointer;
              display: flex;
              justify-content: end;
              flex-direction: column;
              position: relative;
              overflow: hidden;

              &:hover {
                transform: translateY(-6px);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
              }

              .product-image-section {
                position: relative;

                img {
                  width: 100%;
                  height: 100%;
                  padding: 10px;
                  transition: transform 0.4s ease;
                }
              }

              &:hover .product-image-section img {
                transform: scale(1.05);
              }

              .product-info-section {
                box-sizing: border-box;
                padding: 15px 12px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                text-align: center;
                // transition: opacity 0.3s ease, max-height 0.3s ease, padding 0.3s ease, margin 0.3s ease;
                // max-height: 200px;

                .product-name {
                  font-weight: bold;
                  font-size: 18px;
                  color: #222222;
                  margin: 0 0 10px 0;
                  line-height: 1.3;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .product-brief {
                  font-weight: 400;
                  font-size: 14px;
                  color: #666666;
                  line-height: 1.3;
                  margin: 0;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  word-break: break-all;
                  height: 2.6em;
                }
              }

              .card-hover-overlay {
                position: absolute;
                left: 0;
                right: 0;
                top: 77px;
                bottom: 0;
                width: 100%;
                background: linear-gradient(0deg, rgba(29,126,41,0.95) 40%, rgba(29,126,41,0.2) 100%);
                opacity: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                // transition: opacity 0.3s ease, padding 0.3s ease;
                z-index: 2;
                // padding: 16px 0 20px;

                .overlay-content {
                  width: 90%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                }

                .overlay-title {
                  color: #fff;
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 10px;
                  text-align: center;
                  text-shadow: 0 2px 8px rgba(0,0,0,0.15);
                  word-break: break-all;
                }
                .overlay-brief {
                  color: #fff;
                  font-size: 14px;
                  margin-bottom: 24px;
                  text-align: center;
                  line-height: 1.4;
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  word-break: break-word;
                }
                .overlay-plus {
                  width: 48px;
                  height: 46px;
                  display: block;
                  margin: 0 auto;
                }
              }

              &:hover .card-hover-overlay {
                opacity: 1;
                padding: 16px 0 20px;
              }

              &:hover .product-info-section {
                opacity: 0;
                overflow: hidden;
              }
            }
          }
        }
      }

      // 绿色主题样式
      .green-theme {
        .category-title-section {
          .category-name {
            color: #1D7E29;
          }
        }
      }

      // 蓝色主题样式
      .blue-theme {
        .category-title-section {
          .category-name {
            color: #3A5B86;
          }
        }
      }
    }
  }

  // 加载状态样式
  .loading-more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    color: #666;
    font-size: 16px;

    .loading-spinner {
      width: 20px;
      height: 20px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid #1D7E29;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-right: 10px;
    }
  }

  .no-more-data {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    color: #999;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 20px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}
</style>
<style>
.el-carousel__container {
  width: 100vw !;
  height: 642px !important;
}

.el-carousel__indicators--horizontal {
  bottom: 4% !important;
}

/* .el-carousel__item, .el-carousel__mask {
  left:-6px !important;
} */
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue